import React, {useEffect, useState} from "react";
import {NavLink, useNavigate, useSearchParams} from "react-router-dom";
import {validate as isUUID} from "uuid";
import {useEnvironment} from "../../../../../hooks/UseEnvironment";
import ContentBox from "../../../../../components/content-box/ContentBox";
import PageActions from "../../../../base/PageActions";
import ChooseYourStarterState from "../../../../../model/pokemon/ChooseYourStarterState";
import Pokemon from "../../../../../model/pokemon/Pokemon";
import ShareButton from "../../../../../components/share-button/ShareButton";
import _http_service from "../../../../../services/HttpService";
import _image_service from "../../../../../services/ImageService";
import './ChooseYourStarterResultPage.scss';
import '../../../../styles/Common.scss';

interface ChooseYourStarterResultPageProps {
}

const ChooseYourStarterResultPage = (props: ChooseYourStarterResultPageProps) => {

    const _target_client = useEnvironment().targetClient;

    const _unknown_pokemon: Pokemon = {
        id: 'uk',
        name: '',
        shiny: false
    };

    const page: PageActions = new PageActions({
        title: `Choose Your Starter! - Chase the Fox`,
        description: `Build a team of Pokemon by selecting one from a group of three each round!`,
        keywords: ["choose your starter", "pokemon", "randomizer", "team builder", "party builder"],
        imgSrc: `chase/assets/chase_dragonite.png`,
        url: `choose-your-starter`
    });

    const [state, setState] = useState<ChooseYourStarterState>({
        id: "",
        left: _unknown_pokemon,
        center: _unknown_pokemon,
        right: _unknown_pokemon,
        selectedPokemon: [],
        teamSize: 6
    });

    const [params] = useSearchParams();

    const navigateTo = useNavigate();

    const fetchGameState = (id: string): void => {
        _http_service.getChooseYourStarterGameState(id)
            .then(response => {
                setState(response);
            })
            .catch(() => {
                if (!id || !isUUID(id)) {
                    navigateTo('/error', {replace: false});
                }
            });
    }

    useEffect(() => {
        let id: string = params.get('id')!;
        if (!id || !isUUID(id)) {
            navigateTo('/choose-your-starter');
        } else {
            fetchGameState(id);
        }
    }, [params]);

    const getSocialMediaText = (): string => {
        let team = state.selectedPokemon.map(p => p.name).join(", ");
        return `My Choose Your Starter adventure ended with a team of ${team}! What will you get?`;
    }

    return (
        <>
            <ContentBox header="Choose Your Starter Pokemon (Beta)">
                <>
                    <p className="center">
                        Your team is complete! Thank you for playing! An image has been generated for you below to
                        show off your new team! If you would like to play again,
                        please <NavLink to="/choose-your-starter">click here</NavLink>.
                    </p>
                    <div className="cys-result-image">
                        <img src={_image_service.getCdnImageSrc(`common/cys/${state.id}.jpg`, "mobile")}
                             alt={state.selectedPokemon.join(", ")}
                             title="Your Choose Your Starter Pokemon team!"/>
                    </div>
                    <p className="center">
                        Please consider sharing your result on social media! It would mean a lot to me to help spread
                        the word on this game!
                    </p>
                    <ul className="cys-result-socials">
                        <li>
                            <ShareButton type="Twitter"
                                         text={getSocialMediaText()}
                                         url={`${_target_client}cys/result/${state.id}`}/>
                        </li>
                        <li>
                            <ShareButton type="Bluesky"
                                         text={getSocialMediaText()}
                                         url={`${_target_client}cys/result/${state.id}`}/>
                        </li>
                    </ul>
                </>
            </ContentBox>
        </>
    );
}

export default ChooseYourStarterResultPage;